export default __webpack_public_path__ + "static/media/band.7396a011.svg";